const initial_statuses = [
  { name: 'New', value: 'New' },
  { name: 'Planning', value: 'Planning' },
  { name: 'Measured', value: 'Measured' },
  { name: 'Need Measure', value: 'Need Measure' },
  { name: 'Pending', value: 'Pending' },
  { name: 'Approved', value: 'Approved' },
  { name: 'Production', value: 'Production' },
  { name: 'Ready', value: 'Ready' },
  { name: 'Closed', value: 'Closed' },
  { name: 'Rejected', value: 'Rejected' },
];

const initial_project_statuses = [
  { name: 'New', value: 'New' },
  { name: 'Approved', value: 'Approved' },
  { name: 'Ordered', value: 'Ordered' },
  { name: 'Components Arrived', value: 'Components Arrived' },
  { name: 'In Production', value: 'In Production' },
  { name: 'Ready', value: 'Ready' },
  { name: 'Installed', value: 'Installed' },
]

export { initial_statuses, initial_project_statuses };
